import { card, classifyMeld, isWild, rankValues, type Group, type MeldContext } from '@rummy/engine';

export type HandHint = 'run' | 'set' | null;

/**
 * A deliberately restrained hand assistant. It spots a two-card foundation
 * already sitting in one lane, but never recommends an exact draw, leaks deck
 * information, or rearranges a hand without the player asking.
 */
export function findHandHint(groups: readonly Group[], ctx: MeldContext): HandHint {
  for (const group of groups) {
    if (group.length < 2 || classifyMeld(group, ctx) !== null) continue;
    const natural = group.filter((id) => !isWild(id, ctx)).map(card);
    for (let a = 0; a < natural.length; a++) {
      for (let b = a + 1; b < natural.length; b++) {
        const first = natural[a]!;
        const second = natural[b]!;
        if (first.rank === second.rank && first.suit !== second.suit) return 'set';
        if (first.suit !== second.suit || first.rank === null || second.rank === null) continue;
        const distance = Math.min(
          ...rankValues(first.rank, ctx.config).flatMap((one) =>
            rankValues(second.rank!, ctx.config).map((two) => Math.abs(one - two)),
          ),
        );
        if (distance > 0 && distance <= 2) return 'run';
      }
    }
  }
  return null;
}
